module.exports = __webpack_public_path__ + "img/icon_product_hash_logo.a9dffc39.png";